import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes a key-value object and turns it into an array
 * Mostly useful for looping a key-value object in ngFor
 */
@Pipe({name: 'objectToArray', pure: false})
export class ObjectToArrayPipe implements PipeTransform {
  public transform(value: any, args: any[] = null): any {
    const arr = [];

    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        arr.push({
          key: key,
          value: value
        });
      }
    }

    return arr;
  }
}



// WEBPACK FOOTER //
// ./src/app/form/pipes/objectToArray.pipe.ts